import { z } from 'zod';

export const ExplicitConsentReasonSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    reason: z.string().min(1),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateExplicitConsentReasonSchema = ExplicitConsentReasonSchema.omit({ id: true });
export const UpdateExplicitConsentReasonSchema = ExplicitConsentReasonSchema;
export const ExplicitConsentReasonFormSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1, "form.validation.nameRequired"),
    description: z.string().optional(),
});